/*
  Should match source name listed on iglu:com.evvnt/event/jsonschema/1-0-0
 */
export function resolveSourceName(event) {
	const sourceName = event.mainSource;

	if (event.magicBusEvent) {
		return "core";
	}

	if (sourceName === "evvnt") {
		return "marketing";
	} else if (sourceName === "geotix") {
		return "core";
	} else {
		return sourceName;
	}
}

export function resolveEventId(event) {
	// TODO: We are not capturing the event parent id for most sources, only for Evvnt.
	if (event.magicBusEvent) {
		return event.data.core_metadata.event_id;
	} else {
		return String(event.parentId);
	}
}

export function resolveOccurrenceId(event) {
	if (event.magicBusEvent) {
		return event.data.core_metadata.occurrence_id;
	} else {
		return String(event.sourceId);
	}
}
